// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".static-report{padding:0}.static-report h1{font-size:1.5rem}.static-report h3{font-size:1.3rem}.static-report__date-range{font-size:1.1rem;color:#808BA6}.static-report__description{font-size:1.1rem;background:#f1f4fb;width:fit-content;padding:0.5rem;border-radius:5px;margin-top:1rem;margin-bottom:0}\n", ""]);
// Exports
module.exports = exports;
